/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "36d91031617518442581ee5d1725e8cab260dadb";
